import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PostScanTrackingPrompt from '../postScanning/PostScanTrackingPrompt';
import {closeAction, resumePostScan} from '../../actions/productFirstActions';

const PROMPT_TYPES = ['PostScanRecordTracking', 'PostScanVerifyShipping'];

const PutWallPostScanPrompt = () => {
  const dispatch = useDispatch();
  const {isVisible, type, message} = useSelector(
    state => state.productFirst.prompt
  );
  const [inputValue, setInputValue] = useState('');

  if (!isVisible || !PROMPT_TYPES.includes(type)) return null;

  const {orderId, orderIncrementId, remainingModules = [], hasTracking} =
    message || {};
  const isRecord = type === 'PostScanRecordTracking';

  const continueAfter = () => {
    setInputValue('');
    dispatch(closeAction());
    dispatch(resumePostScan(remainingModules));
  };

  return (
    <PostScanTrackingPrompt
      mode={isRecord ? 'record' : 'verify'}
      orderId={orderId}
      orderNumber={orderIncrementId || orderId}
      hasTracking={hasTracking}
      value={inputValue}
      onChangeText={setInputValue}
      onComplete={continueAfter}
    />
  );
};

export default PutWallPostScanPrompt;
